import React, { ComponentType } from 'react';

import { TDispatch } from 'utils';

import { IContactDetailsProps } from '../../../ContactDetails';
import { ICounsellorProps } from '../../../Counsellor';
import { IDateAndTimeProps } from '../../../DateAndTime';
import { IConfirmDetailsProps } from '../../../ConfirmDetails';
import { IPreferencesProps } from '../../../Preferences';
import { ISummaryProps } from '../../../Summary';
import { formSteps, IFormState, TSteps } from '../../types';

const RenderStep = ({
  service,
  step,
  answers,
  details,
  errors,
  dispatch,
}: {
  service: IFormState['service'];
  step: TSteps[number]['key'];
  answers: IFormState['answers'];
  errors?: IFormState['errors'];
  details?: IFormState['details'];
  dispatch: TDispatch;
}) => {
  const props = {
    service,
    step,
    formData: answers,
    errors,
    dispatch,
  };

  switch (step) {
    case 0: {
      const StepComponent = formSteps[0]
        .component as ComponentType<IContactDetailsProps>;

      return (
        <StepComponent {...props} details={details} answers={answers[0]} />
      );
    }
    case 1: {
      const StepComponent = formSteps[1]
        .component as ComponentType<IPreferencesProps>;

      return <StepComponent {...props} answers={answers[1]} />;
    }
    case 2: {
      const StepComponent = formSteps[2]
        .component as ComponentType<IDateAndTimeProps>;

      return <StepComponent {...props} answers={answers[2]} />;
    }
    case 3: {
      const StepComponent = formSteps[3]
        .component as ComponentType<ICounsellorProps>;

      return <StepComponent {...props} answers={answers[3]} />;
    }
    case 4: {
      const StepComponent = formSteps[4]
        .component as ComponentType<IConfirmDetailsProps>;

      return (
        <StepComponent {...props} details={details} answers={answers[4]} />
      );
    }
    case 5: {
      const StepComponent = formSteps[5]
        .component as ComponentType<ISummaryProps>;

      return <StepComponent {...props} details={details} />;
    }
    default:
      return <></>;
  }
};

export default RenderStep;
